import type {ModalAction} from 'src/action-creators/modal';
import type {ModalStateEntry} from 'src/types/modal';

import {
  PUSH_MODAL,
  POP_MODAL,
  REPLACE_MODAL,
  SET_ERROR_MODAL,
  REMOVE_ERROR_MODAL,
  PUSH_SIDEPANEL,
} from 'src/action-creators/modal';


export type ModalState = {
  entries: ModalStateEntry[];
  error: ModalStateEntry | null | undefined;
};

const initialState = {
  entries: [],
  error: null,
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly entries: readonly []; readonly error: null; }' is not assignable to type 'ModalState'.
  state: ModalState | null | undefined = initialState,
  action: ModalAction,
): ModalState => {
  switch (action.type) {
    case PUSH_MODAL:
      // @ts-expect-error - TS2322 - Type '{ entries: (ModalStateEntry | { type: any; props: Modal; })[]; error?: ModalStateEntry | null | undefined; }' is not assignable to type 'ModalState'.
      return {
        ...state,
        entries: [
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.entries,
          action.payload.render
            ? action.payload
            : {
                type: action.payload.type,
                props: action.payload,
              },
        ],
      };
    case REPLACE_MODAL:
      // @ts-expect-error - TS2322 - Type '{ entries: (ModalStateEntry | { type: any; props: Modal; })[]; error?: ModalStateEntry | null | undefined; }' is not assignable to type 'ModalState'.
      return {
        ...state,
        entries: [
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.entries.slice(0, -1),
          action.payload.render
            ? action.payload
            : {
                type: action.payload.type,
                props: action.payload,
              },
        ],
      };
    case POP_MODAL:
      // @ts-expect-error - TS2322 - Type '{ entries: ModalStateEntry[]; error?: ModalStateEntry | null | undefined; }' is not assignable to type 'ModalState'.
      return {
        ...state,
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        entries: state.entries.slice(0, -1),
      };
    case SET_ERROR_MODAL:
      // @ts-expect-error - TS2322 - Type '{ error: { type: any; props: Modal; }; entries?: ModalStateEntry[] | undefined; }' is not assignable to type 'ModalState'.
      return {
        ...state,
        error: {
          type: action.payload.type,
          props: action.payload,
        },
      };
    case REMOVE_ERROR_MODAL:
      // @ts-expect-error - TS2322 - Type '{ error: null; entries?: ModalStateEntry[] | undefined; }' is not assignable to type 'ModalState'.
      return {
        ...state,
        error: null,
      };
    case PUSH_SIDEPANEL:
      // @ts-expect-error - TS2322 - Type '{ entries: (ModalStateEntry | { type: any; props: Sidepanel; })[]; error?: ModalStateEntry | null | undefined; }' is not assignable to type 'ModalState'.
      return {
        ...state,
        entries: [
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.entries,
          {
            type: action.payload.type,
            props: action.payload,
          },
        ],
      };
  }
  // @ts-expect-error - TS2322 - Type 'ModalState | null' is not assignable to type 'ModalState'.
  return state;
};
